import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import { handleJsonApiError } from "jsonapi-zod-query";

export const useDeleteCompanyPhoneNumber = (): UseMutationResult<
    void,
    Error,
    { phoneNumberUUID: string }
> => {
    const fetch = useAuthenticatedFetch();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ phoneNumberUUID }) => {
            const response = await fetch(apiUrl("/company/phone-number/delete"), {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify({
                    phoneNumberUUID: phoneNumberUUID,
                }),
            });
            await handleJsonApiError(response);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["company-phone-number-table-data"],
            });
        },
    });
};
